import { Helmet } from 'react-helmet-async';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// @mui
import {
    Card,
    Table,
    Stack,
    TableRow,
    TableBody,
    TableCell,
    Container,
    Typography,
    IconButton,
    TableContainer,
    Menu,
    MenuItem,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

// sections
// mock
import { eventList, glb_sv, sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import DepartmentListHead from 'src/sections/@dashboard/department/DepartmentListHead';
import ButtonAction from 'src/components/Button.js/SaveButton';
import Label from 'src/components/label/Label';

import debounce from 'lodash/debounce';
import DrawerSidebar from 'src/components/DrawerSidebar/DrawerSidebar';
import Loader from 'src/components/loader/loader';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import ChessBoard from 'src/components/ChessBoard/ChessBoard';
import crypt from 'src/utils/service/crypt';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import ChangeUserTake from 'src/components/modal/ChangeUserTake';
import moment from 'moment';
import ItemCategory from './categorty/ItemCategory';

// ----------------------------------------------------------------------

export default function CategoryPage() {
    const [actionDeviceOnline, setActionDeviceOnline] = useState(false);
    const actionRef = useRef();
    const [arrCategory, setCategory] = useState([]);
    const [arrRendered, setRendered] = useState([]);
    const [openSibarDevice, setopenSibarDevice] = useState(false);

    const [dataCategoryOnline, setDataCategoryOnline] = useState([]);
    const [isVisibleUpdate, setIsVisibleUpdate] = useState(false);

    const [note, setNote] = useState('');
    const [quantity, setQuantity] = useState(1);
    const [userHelper, setUserHelper] = useState(1);

    const { t } = useTranslation();
    const dataActionRef = useRef(null);
    const [getFlags, setGetFlags] = useState(false);
    const getRef = useRef(false);
    const [tableData, setTableData] = useState([]);

    const [dataAction, setDataAction] = useState({});

    const tableRef = useRef(null);
    const throttled = useRef(debounce((dataChange) => handleAddQtyDevice(dataChange), 1000));
    const userRef = useRef(null);

    const [visibleDel, setVisibleDel] = useState(false);
    const [deleteFlags, setDeleteFlags] = useState(false);
    const anchorTabEdit = useRef(null);
    const [openEdit, setOpenEdit] = useState(false);

    useMemo(() => {
        try {
            userRef.current = JSON.parse(crypt.deCode(sessionStorage.getItem('proc_data')));
        } catch (error) {}
    }, []);
    // console.log("userRef: ", userRef.current)

    useEffect(() => {
        const data = sessionStorage.getItem('category');
        if (data) {
            try {
                setCategory(JSON.parse(data));
            } catch (error) {}
        }
    }, [arrRendered]);

    // useEffect(() => {
    //     glb_sv.commonEvent.subscribe((msg) => {
    //         if (msg.type === eventList.ADD_PRODUCT) {
    //             const data = sessionStorage.getItem('category');
    //             if (data) {
    //                 try {
    //                     setCategory(JSON.parse(data));
    //                 } catch (error) {}
    //             }
    //             getData();
    //         }
    //     });
    // }, []);

    useEffect(() => {
        // Optimize: Use Map-Sort-Map to calculate timestamp only once per item
        const getTimestamp = (time) => {
            if (!time) return 0;
            if (typeof time === 'number') return time;
            // Manual parsing for 'YYYYMMDDHHmmss' is significantly faster than moment/Date parsing
            if (typeof time === 'string' && time.length === 14) {
                const y = +time.substring(0, 4);
                const m = +time.substring(4, 6) - 1;
                const d = +time.substring(6, 8);
                const h = +time.substring(8, 10);
                const min = +time.substring(10, 12);
                const s = +time.substring(12, 14);
                return new Date(y, m, d, h, min, s).getTime();
            }
            return new Date(time).getTime();
        };

        // Combine and map to temporary structure with pre-calculated timestamp
        const mappedData = [...dataCategoryOnline, ...arrCategory].map((item) => ({
            data: item,
            timestamp: getTimestamp(item.create_time),
        }));

        // Sort fast on primitive numbers
        mappedData.sort((a, b) => b.timestamp - a.timestamp);

        // Extract original data
        setTableData(mappedData.map((item) => item.data));
    }, [arrCategory, dataCategoryOnline]);

    const TABLE_HEAD = [
        { id: 'name', label: t('device'), alignRight: false },
        { id: 'company', label: t('info'), alignRight: false },
        { id: 'role', label: t('role'), alignRight: false },
        { id: 'quantity_category', label: t('quantity_category'), alignRight: false },
        { id: 'note', label: t('note_'), alignRight: false },
        { id: 'requester_name_device', label: t('requester_name_device'), alignRight: false },
        { id: 'helper_name_device', label: t('helper_name_device'), alignRight: false },
        { id: 'Thao tác', label: '', alignRight: false },
        { id: '1', label: '', alignRight: false },
        { id: '2', label: '', alignRight: false },
    ];

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 600);
    }, []);

    // useEffect(() => {
    //     window.addEventListener('beforeunload', handleBeforeUnload);

    //     return () => {
    //         window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    // }, []);

    // const handleBeforeUnload = (event) => {
    //     event.preventDefault();
    //     event.returnValue = '';
    // };

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [];
        sendRequest(serviceList.getListRegisterDeviceOnline, InVal, getDataResult, true, timeOutFunct, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        setGetFlags(false);
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // console.log("Process", message.proc_data.rows[0].o_1)
            setDataCategoryOnline(message.proc_data.rows[0].o_1);

            glb_sv.commonEvent.next({ type: eventList.ADD_PRODUCT, data: message.proc_data.rows[0].o_1.length });
        }
    };

    const timeOutFunct = (reqInfo) => {
        setGetFlags(false);
        getRef.current = false;
        toast.error(t('error.time_out'));
    };

    const handleDelete = () => {
        setDeleteFlags(true);
        handleActionDevice(dataActionRef.current.id);
    };

    // delete device category online
    const handleActionDevice = (id, type) => {
        if (actionRef.current) return;
        actionRef.current = true;
        const InVal = [id];
        sendRequest(serviceList.deleteDeviceOnline, InVal, actionDeviceResult, true, timeOutFunctActionDevice, 40000);
        setDeleteFlags(false);
    };
    // delete device category online result
    const actionDeviceResult = (reqInfoMap, message) => {
        actionRef.current = false;

        setVisibleDel(false);
        setIsVisibleUpdate(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            getData();
        }
    };

    const timeOutFunctActionDevice = (reqInfo) => {
        actionRef.current = false;
        toast.error(t('error.time_out'));
    };
    // delete device offline
    const handleRomoveProduct = (data) => {
        try {
            const index = arrCategory.indexOf(data);
            if (index >= 0) {
                arrCategory.splice(index, 1);
                const arr = arrCategory;
                sessionStorage.setItem('category', JSON.stringify(arrCategory));
                setRendered(arr);
                glb_sv.commonEvent.next({ type: eventList.ADD_PRODUCT, data: 'add' });
            } else {
                // toast.error('Không thể xóa thiết bị ra khỏi giỏ hàng');
            }
        } catch (error) {}
    };

    const addQuantity = (data, index, key) => {
        if (key) {
            if (index >= 0) {
                throttled.current({ ...data, qty: data.qty + 1 });
                const arr = [...tableData];
                arr[index].qty = arr[index].qty + 1;
                setTableData(arr);
            }
        } else {
            if (data.qty > 1) {
                throttled.current({ ...data, qty: data.qty - 1 });
                const arr = [...tableData];
                arr[index].qty = arr[index].qty - 1;
                setTableData(arr);
            }
        }
    };

    const handleAddQtyDevice = (data, quantity = null, note = null, userHelpChange = null) => {
        if (!data) return;
        if (data.onl) {
            if (actionRef.current) return;
            actionRef.current = true;
            const InVal = [
                quantity || data.qty,
                data?.id,
                '1',
                data?.cell_id,
                userHelpChange?.id || data.helper_id,
                note || data?.note,
            ];

            sendRequest(
                serviceList.changeQtyDeviceOnlineUpdate,
                InVal,
                actionAddQtyDeviceResult,
                true,
                timeOutFunctActionAddQtyDevice,
                40000
            );
        } else {
            try {
                const dataArr = JSON.parse(sessionStorage.getItem('category'));
                let position = -1;
                for (let i = 0; i < dataArr.length; i++) {
                    if (dataArr[i].idCategory === data.idCategory) position = i;
                }
                if (position >= 0) {
                    dataArr[position] = data;
                    setRendered(dataArr);
                    sessionStorage.setItem('category', JSON.stringify(dataArr));
                    glb_sv.commonEvent.next({ type: eventList.ADD_PRODUCT, data: 'add' });
                }
            } catch (error) {}
        }
    };

    const actionAddQtyDeviceResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            getData();
            // toast.error('Error: ' + message['proc_message']);
        }
    };

    const timeOutFunctActionAddQtyDevice = (reqInfo) => {
        actionRef.current = false;
        toast.error(t('error.time_out'));
    };

    return (
        <>
            <Helmet>
                <title> {t('gio_hang')} </title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4" gutterBottom>
                        {t('gio_hang')}
                    </Typography>
                </Stack>{' '}
                <Breadcrumb paths={[{ label: t('gio_hang'), url: '#', navigate: false }]} />
                <DrawerSidebar
                    open={openSibarDevice}
                    onClose={() => setopenSibarDevice(false)}
                    onOpen={() => setopenSibarDevice(true)}
                    setOpen={setopenSibarDevice}
                    getData={getData}
                    setDataCategoryOnline={setCategory}
                    actionDeviceOnline={actionDeviceOnline}
                    device={dataAction}
                />
                <Loader loading={actionDeviceOnline} />
                <Card>
                    <Scrollbar>
                        <TableContainer>
                            <Table ref={tableRef}>
                                <DepartmentListHead
                                    order={'asc'}
                                    orderBy={'name'}
                                    headLabel={TABLE_HEAD}
                                    rowCount={tableData.length}
                                />
                                <TableBody>
                                    {tableData.length > 0 &&
                                        tableData.map((item, index) => {
                                            return (
                                                <ItemCategory
                                                    key={index}
                                                    item={item}
                                                    index={index}
                                                    addQuantity={addQuantity}
                                                    dataActionRef={dataActionRef}
                                                    setVisibleDel={setVisibleDel}
                                                    handleRomoveProduct={handleRomoveProduct}
                                                    setIsVisibleUpdate={setIsVisibleUpdate}
                                                    setNote={setNote}
                                                    setQuantity={setQuantity}
                                                    setUserHelper={setUserHelper}
                                                    setDataAction={setDataAction}
                                                    setopenSibarDevice={setopenSibarDevice}
                                                    userRef={userRef}
                                                />
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>
                </Card>
                <ConfirmModal
                    loading={deleteFlags}
                    visible={visibleDel}
                    setVisible={setVisibleDel}
                    handleDelete={handleDelete}
                />
                <ChangeUserTake
                    note={note}
                    setnote={setNote}
                    quantity={quantity}
                    setQuantity={setQuantity}
                    product={dataActionRef.current}
                    callBackFunct={(data, quantity, note, userHelpChange) => {
                        handleAddQtyDevice(data, quantity, note, userHelpChange);
                    }}
                    visible={isVisibleUpdate}
                    setVisible={setIsVisibleUpdate}
                    isRegisterOnline
                    userHelper={userHelper}
                />
            </Container>
        </>
    );
}
